import {
  Box,
  Flex,
  Heading,
  IconButton,
  LinkBox,
  LinkOverlay,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BusStop } from "../../data/buses.api";
import BusStopHeading from "./BusStopHeading";
import BusTimes from "./BusTimes";

type Props = {
  busStop: BusStop;
  showBusTimes?: boolean;
};

const BusStopPreview = ({ busStop, showBusTimes = true }: Props) => {
  const bg = useColorModeValue("gray.50", "whiteAlpha.50");
  const titleColour = useColorModeValue("lancsBlue.500", "lancsBlue.300");
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => navigate(`/buses/${busStop.atcoCode}`)}
      bg={bg}
      p={5}
      cursor="pointer"
      rounded="lg"
    >
      <Flex
        justify="space-between"
        alignItems={showBusTimes ? "start" : "center"}
      >
        <BusStopHeading size="sm" color={titleColour} busStop={busStop} />
      </Flex>
      {showBusTimes ? (
        <Box data-testid="bustimes" mt={3}>
          <BusTimes atcoCode={busStop.atcoCode} limit={3} />
        </Box>
      ) : null}
    </Box>
  );
};

export default BusStopPreview;
